<template>
  <a-layout class='s_bf'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="礼品名称" name='name'>
          <a-input v-model:value="search.name" style="width:270px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="礼品分类" name='ex_gift_cate_id'>
          <a-cascader :options="loadData" v-model:value="search.ex_gift_cate_id" style="width:270px"
            :field-names="{ label: 'name', value: 'id', children: 'child' }" placeholder="请选择礼品分类" allowClear/>
        </a-form-item>
        <a-form-item name="">
          <a-button type="primary" htmlType='submit' >搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:info="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+record.image" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>
              <p>{{record.name}}</p>
              <span v-if='record.price_type == 2'>{{record.price}}元+</span>
              <span class="m-r-5">{{record.point}}积分</span>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="primary" @click='select(record)' :ghost="!record.select" v-if='!checkout'>推荐</a-button>
          <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>推荐</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper  :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"  @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
      <div class="s_flex_center m-t-25" v-if="checkout">
        <a-button type="primary" @click='confirm'>确定</a-button>
      </div>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { useTree } from '@/hooks/useTree.js'
  import {
    exchangeGift,
    getCategory
  } from "@/api/integralShop";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    status: 1,
    name:'',
    ex_gift_cate_id: ""
  };
  export default {
    name: "selectGift",
    props: {
      checkout: Boolean,
      selectList: {
        type: Array
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref();
      search.value = { ...defSearch }
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 1,
        loadData: [],
        selectList: [],//被选中的列表
      });
      let columns = [
        {
          title: "礼品信息",
          dataIndex: "info",
          key: "info",
          slots: { customRender: "info" }
        },
        {
          title: "操作",
          key: "action",
          width:120,
          slots: { customRender: "action" },
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 获取分类
      const initCate = async () => {
        let result = await getCategory().then((res) => res.data);
        state.loadData = useTree(result.data);
        state.loadData.map((v) => (v.disabled = v.child.length == 0 ? true : false));
      };
      const form = ref();
      const initData = async (values) => {
        var json = JSON.parse(JSON.stringify(search.value))
        state.listLoading = true;
        let res = await exchangeGift({...json,ex_gift_cate_id:json.ex_gift_cate_id[1]}).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
          if (state.selectList.length > 0) {
            data.value.forEach(i => {
              if (state.selectList.find(v => i.id == v.id)) {
                i.select = true
              }
            })
          }
        } else {
          message.error(res.msg);
        }
      };

      //单选
      const select = (e) => {
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        // if(state.selectList.filter(v=>v.select).length == 10){
        //   message.error('最多可选10个礼品！')
        //   return false
        // }
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.id == e.id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const _lodash = inject("_lodash");
      const confirm = () => {
        emit("select", _lodash.uniqBy(state.selectList, 'id'));
      }
      onMounted(() => {
        state.selectList = JSON.parse(JSON.stringify(props.selectList))
        initData(search.value);
        initCate();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        form,
        confirm,
        select,
        checkBnt
      };
    },
  };
</script>